import lobbyWidgetIcon from './cart.webp';
import mysteryBoxFlare from './flare.webp';
import saleBadge from './sale-badge.webp';

export default {
  lobbyWidgetIcon,
  mysteryBoxFlare,
  saleBadge,
};
